import Box from '@totallymoney/ui/components/Box'
import Card from '@totallymoney/ui/components/Card'
import Heading from '@totallymoney/ui/components/Heading'
import LinkWithChevron from '@totallymoney/ui/components/LinkWithChevron'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'
import Image from 'next/image'
import { useEffect } from 'react'

import { getAppConfig } from '@utils/getAppConfig'

import useLogEvents from '@hooks/useLogEvents'

import womanHoldingPhoneImage from '../../public/images/woman-holding-phone.png'

interface EligibilityFactorsCardProps {
    isOnBoardingRequired: boolean
    numberOfRedEligibilityFactors?: number
    route: 'alternativeProducts'
}

const EligibilityFactorsCard = ({
    isOnBoardingRequired = false,
    numberOfRedEligibilityFactors = 0,
    route,
}: EligibilityFactorsCardProps) => {
    const appConfig = getAppConfig()

    const logEvents = useLogEvents()

    const showEligibilityFactorCard =
        (isOnBoardingRequired || numberOfRedEligibilityFactors >= 1) &&
        window.innerWidth <= 425

    useEffect(() => {
        if (showEligibilityFactorCard) {
            logEvents.logEligibilityFactorsCardShownEvent({
                numberOfRedEligibilityFactors,
                isOnBoardingRequired,
            })
        }
    }, [
        logEvents,
        numberOfRedEligibilityFactors,
        isOnBoardingRequired,
        showEligibilityFactorCard,
    ])

    const onT20UpgradeLinkClick = () => {
        logEvents.logEligibilityFactorsCardT20UpgradeLinkClickEvent({
            route,
        })
    }

    const onDeepLinkClick = () => {
        logEvents.logEligibilityFactorsCardDeepLinkClickEvent({
            numberOfRedEligibilityFactors,
            route,
        })
    }

    if (showEligibilityFactorCard === false) {
        return null
    }

    return (
        <Card display="flex" p="space30" flexDirection="row">
            <Box mr="space20">
                <Image
                    src={womanHoldingPhoneImage}
                    width={64}
                    height={64}
                    alt="Woman holding a phone with an alert appearing"
                />
            </Box>
            <Box flex={1}>
                <Box mb="space10">
                    <Heading variant="40">Improve eligibility</Heading>
                </Box>
                {isOnBoardingRequired ? (
                    <>
                        <Box mb="space20">
                            <Text color="light">
                                Find out how you could get better offers in the
                                future
                            </Text>
                        </Box>
                        <LinkWithChevron
                            href={`${appConfig.ACCOUNT_URL}upgrade?route=creditCardsAlternativeProducts`}
                            onClick={onT20UpgradeLinkClick}
                        >
                            Get your credit report
                        </LinkWithChevron>
                    </>
                ) : (
                    <>
                        <Box mb="space20">
                            <Text color="light" display="inline">
                                You have{' '}
                            </Text>
                            <Text weight="bold" display="inline">
                                {numberOfRedEligibilityFactors === 1
                                    ? '1 factor'
                                    : `${numberOfRedEligibilityFactors} factors`}
                            </Text>
                            <Text color="light" display="inline">
                                {' '}
                                holding you back
                            </Text>
                        </Box>
                        <LinkWithChevron
                            href="https://totallymoney.app.link/Pb40GbFujwb"
                            onClick={onDeepLinkClick}
                        >
                            See in the app
                        </LinkWithChevron>
                    </>
                )}
            </Box>
        </Card>
    )
}

export default EligibilityFactorsCard
